import type { TablePaginationConfig } from 'antd/es/table';

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const;
export const DEFAULT_PAGE_SIZE = 10;

const showTotal: NonNullable<TablePaginationConfig['showTotal']> = (total, [from, to]) =>
  `第 ${from}-${to} 条 / 共 ${total} 条`;

/** 客户端分页（全量数据在前端 Table 内切页） */
export function clientTablePagination(
  overrides?: Partial<TablePaginationConfig>
): TablePaginationConfig {
  return {
    showSizeChanger: true,
    pageSizeOptions: [...PAGE_SIZE_OPTIONS].map(String),
    defaultPageSize: DEFAULT_PAGE_SIZE,
    showTotal,
    ...overrides,
  };
}

/** 服务端分页（page 为 0-based） */
export function serverTablePagination(opts: {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}): TablePaginationConfig {
  return {
    current: opts.page + 1,
    pageSize: opts.pageSize,
    total: opts.total,
    showSizeChanger: true,
    pageSizeOptions: [...PAGE_SIZE_OPTIONS].map(String),
    showTotal,
    onChange: (nextPage, nextSize) => {
      if (nextSize !== opts.pageSize) {
        opts.onPageSizeChange(nextSize);
        opts.onPageChange(0);
        return;
      }
      opts.onPageChange(nextPage - 1);
    },
    onShowSizeChange: (_current, nextSize) => {
      opts.onPageSizeChange(nextSize);
      opts.onPageChange(0);
    },
  };
}
